import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalDialogContainerDirective } from '@frontend/sports/modal/feature';

import { WidgetColumnComponent } from './widget-column.component';
import { WidgetLayoutComponent } from './widget-layout.component';
import { WidgetSlotComponent } from './widget-slot.component';

@NgModule({
    imports: [CommonModule, ModalDialogContainerDirective],
    declarations: [WidgetLayoutComponent, WidgetSlotComponent, WidgetColumnComponent],
    exports: [WidgetLayoutComponent, WidgetSlotComponent, WidgetColumnComponent],
})
export class WidgetCoreModule {}
